const SvgDarkHomeHero = (props) => (
  <svg viewBox="0 0 833 390" xmlns="http://www.w3.org/2000/svg">
    <path d="M467 130v259H209l258-259Z" fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M274.544 322.884c15.783 15.783 37.587 25.545 61.67 25.545 48.167 0 87.214-39.047 87.214-87.214 0-24.084-9.761-45.888-25.544-61.67l-123.34 123.339Z"
      fill="#363636"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M422.713 249.991c-2.518-19.595-11.539-37.156-24.829-50.446L274.545 322.884C258.762 307.102 249 285.298 249 261.214 249 213.047 288.047 174 336.214 174c44.364 0 80.992 33.125 86.499 75.991Z"
      fill="#3763FF"
    />
    <path fill="#BC6038" d="M467 130h258v259H467z" />
    <path d="M524 285c0-40.317 32.683-73 73-73s73 32.683 73 73v105H524V285Z" fill="#363636" />
    <path fill="#2525D7" d="M725 289h108v100H725z" />
    <path fill="#3763FF" d="M614 289h56v100h-56z" />
    <path fill="#FCFCFC" d="M670 289h55v101h-55z" />
    <circle cx={144} cy={325} r={65} fill="#D0AE86" />
    <circle cx={632} cy={65} r={65} fill="#3763FF" />
    <path d="M33.59 337 66 389H0l33.59-52Z" fill="#3763FF" />
  </svg>
);

export default SvgDarkHomeHero;
